// Component TypeScript
import {Component, inject, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ToastService} from '../../../../services/layout/toast.service';
import {MaterialModule} from "../../../../material.module";

import {ITemplateMessage} from "../../../../models/chatbot-options.model";
import {DisabledButtonReasonComponent} from "../../../shared/disabled-button-reason/disabled-button-reason.component";

@Component({
  selector: 'app-messages-settings',
  templateUrl: './messages-settings.component.html',
  styleUrls: ['./messages-settings.component.scss'],
    imports: [MaterialModule, ReactiveFormsModule, DisabledButtonReasonComponent]
})
export class MessagesSettingsComponent implements OnInit {
    private fb = inject(FormBuilder);
    private snackBar = inject(ToastService);

  @Input() messagesForm: FormGroup;

  ngOnInit(): void {
    if (!this.messagesForm) {
      throw new Error('messagesForm Input is required for MessagesSettingsComponent');
    }
    this.initializeFormArrays();
  }

  private initializeFormArrays() {
    if (this.errorMessages?.length === 0) {
      this.addErrorMessage();
    }
    if (this.waitMessages?.length === 0) {
      this.addWaitMessage();
    }
  }

  get errorMessages(): FormArray {
    return this.messagesForm.get('errorMessages') as FormArray;
  }
  get waitMessages(): FormArray {
    return this.messagesForm.get('waitMessages') as FormArray;
  }

  get errorMessageRemoveDisabled(): boolean {
    return this.errorMessageRemoveDisabledReason.length > 0;
  }

  get errorMessageRemoveDisabledReason(): string {
    if (this.errorMessages.length === 1) return 'At least one error message is required.';
    return '';
  }

  get waitMessageRemoveDisabled(): boolean {
    return this.waitMessageRemoveDisabledReason.length > 0;
  }

  get waitMessageRemoveDisabledReason(): string {
    if (this.waitMessages.length === 1) return 'At least one wait message is required.';
    return '';
  }

  private createErrorMessageGroup(errorMessage?: ITemplateMessage): FormGroup {
    return this.fb.group({
      message: [errorMessage?.message || '', Validators.required]
    });
  }
  private createWaitMessageGroup(waitMessage?: ITemplateMessage): FormGroup {
    return this.fb.group({
      message: [waitMessage?.message || '', Validators.required]
    });
  }

  addErrorMessage(): void {
    this.errorMessages.push(this.createErrorMessageGroup());
    this.snackBar.showSuccess('Error message added.', 3000);
  }
  removeErrorMessage(index: number): void {
    if (this.errorMessages.length > 1) {
      this.errorMessages.removeAt(index);
      this.snackBar.showSuccess('Error message removed.', 3000);
    } else {
      this.snackBar.showError('At least one error message is required.', 3000);
    }
  }

  addWaitMessage(): void {
    this.waitMessages.push(this.createWaitMessageGroup());
    this.snackBar.showSuccess('Wait message added.', 3000);
  }
  // Corrected comment to indicate removal of a wait message
  removeWaitMessage(index: number): void {
    if (this.waitMessages.length > 1) {
      this.waitMessages.removeAt(index);
      this.snackBar.showSuccess('Wait message removed.', 3000);
    } else {
      this.snackBar.showError('At least one wait message is required.', 3000);
    }
  }

  trackByIndex(index: number, _item: any): number {
    return index;
  }
}
